export default {
  "close-btn": "_close-btn_8m9la7 btn btn--icon-only btn--tertiary"
};